module.exports = __webpack_public_path__ + "img/detail-phone.c83c1619.svg";